import { APPLICATIONS_ID } from "@/constants";

const ASG_MAX_HIGHLIGHTS_PLACEHOLDER =
  "A muscular 25 year old athletic male, with shaggy brown hair, brown eyes, and a ragged baseball cap. He's witty and charming, with a smile that lights up the room.";

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getProfileHighlightsPlaceholder = (applicationId: APPLICATIONS_ID, t: (key: string) => string) => {
  switch (applicationId) {
    case APPLICATIONS_ID.AsgMax:
      return ASG_MAX_HIGHLIGHTS_PLACEHOLDER;
    default:
      return t("user:profile.form.highlights.placeholder");
  }
};

export default getProfileHighlightsPlaceholder;
